import { render, staticRenderFns } from "./product_m.vue?vue&type=template&id=1c07f424&scoped=true"
import script from "./product_m.vue?vue&type=script&lang=js"
export * from "./product_m.vue?vue&type=script&lang=js"
import style0 from "./product_m.vue?vue&type=style&index=0&id=1c07f424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c07f424",
  null
  
)

export default component.exports